/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.CRM {

    @Serenity.Decorators.registerClass()
    export class LognotesDialog extends NoboxEntityDialog<LognotesRow, any> {
        protected getFormKey() { return LognotesForm.formKey; }
        protected getIdProperty() { return LognotesRow.idProperty; }
        protected getLocalTextPrefix() { return LognotesRow.localTextPrefix; }
        protected getNameProperty() { return LognotesRow.nameProperty; }
        protected getService() { return LognotesService.baseUrl; }
        protected getDeletePermission() { return LognotesRow.deletePermission; }
        protected getInsertPermission() { return LognotesRow.insertPermission; }
        protected getUpdatePermission() { return LognotesRow.updatePermission; }

        protected form = new LognotesForm(this.idPrefix);
        protected updateInterface() {
            super.updateInterface();
            var $form = this.form;
            Serenity.EditorUtils.setReadonly(this.element.find('.editor'), false);
            if (this.isEditMode()) {
                $form.Activity.value = "Updated a note";
            } else {
                $form.Activity.value = "Added a note";
            }
        }
    }
}